/*
Monotype Foundry Platform API
Version 1.0.0

Definition: ImageUploadRequest

Properties:
  images: array
*/

var ImageUploadRequest = (function () {
  function validateImageUploadRequest (arg) {
    // Validate images
    if (arg.images && !(Array.isArray(arg.images))) {
      throw new Error('ImageUploadRequest.images: Wrong type: Got \'' + (typeof arg.images) + '\', but expected: \'array\'')
    }
  }
  function buildImageUploadRequest (arg) {
    var ImageUploadRequest = arg
    // Complete images
    // Expected Type: array
    ImageUploadRequest.images = ImageUploadRequest.images || []
    return ImageUploadRequest
  }
  return {
    validate: validateImageUploadRequest,
    build: buildImageUploadRequest
  }
})()

module.exports = ImageUploadRequest
